import c from "classnames";
import { PropsWithChildren } from "react";

import { CardBody } from "./ui/CardBody/CardBody";
import { CardFooter } from "./ui/CardFooter/CardFooter";
import { CardHeader } from "./ui/CardHeader/CardHeader";

import classes from "./Card.module.css";

type Props = PropsWithChildren<{
  stretch?: boolean;
  grow?: boolean;
  shadow?: boolean;
}>;

export const Card = ({
  stretch = true,
  grow = false,
  shadow = true,
  ...props
}: Props) => {
  return (
    <div
      className={c(
        classes.card,
        stretch && classes.stretch,
        grow && classes.grow,
        shadow && classes.shadow,
      )}
      {...props}
    />
  );
};

Card.Header = CardHeader;
Card.Body = CardBody;
Card.Footer = CardFooter;
